/**
 * Microsoft Clarity install snippet.
 * Replace YOUR_CLARITY_PROJECT_ID with the project ID from clarity.microsoft.com.
 * Place in <head> of theme.liquid, above any other scripts.
 *
 * Collects baseline heatmap + session recording data. Free tier is unlimited.
 * 7-day baseline required before shipping conversion elements per Rec #15.
 */
(function(c,l,a,r,i,t,y){
  c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
  t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
  y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
})(window, document, "clarity", "script", "wcd0t5pflw");

// Tag blog sessions so they can be filtered in Clarity dashboard
if (window.clarity) {
  var isArticle = document.body.classList.contains('template-article') ||
                  (window.Shopify && window.Shopify.template === 'article');
  if (isArticle) {
    clarity('set', 'page_type', 'blog_article');
    if (window.BLOG_POST_META) {
      clarity('set', 'post_theme', window.BLOG_POST_META.theme || 'unknown');
      clarity('set', 'post_slug', window.BLOG_POST_META.handle || '');
    }
  }
}
